import { createAction, props } from "@ngrx/store";
import { ModalConfirm, ModalForm } from "../models/modal-confirm";
import { Alert } from "../models/alert";

export const openModalConfirm = createAction('OPEN_MODAL_CONFIRM', props<ModalConfirm>());
export const openModalForm = createAction('OPEN_MODAL_CONFIRM', props<ModalForm>());
export const resetModalConfirm = createAction('RESET_MODAL_CONFIRM');
export const openAlert = createAction('OPEN_ALERT', props<Alert>());
export const closeAlert = createAction('CLOSE_ALERT');
export const openSpinner = createAction('OPEN_SPINNER');
export const closeSpinner = createAction('CLOSE_SPINNER');
export const viewSidebar = createAction('VIEW_SIDEBAR');

